import React from 'react';
import Button from '@material-ui/core/Button';
import { ArrowBack } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

const LogoutButton = (prop) => {
    const useStyles = makeStyles((theme) => ({
        controlPanel: {
            display: "flex",
            flexWrap: "wrap",
        }
    }));

    const handleClick = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('permissions');
        localStorage.removeItem('authenticated');
        window.location = process.env.REACT_APP_BASE_ENTRYPOINT + '/auth/logout';
    }

    const classes = useStyles();

    return (
        <div className={classes.controlPanel}>
            <Button variant="contained" color="primary" className="loguot-btn" onClick={handleClick}>
                <ArrowBack className="icon-loguot-btn" /> Назад
            </Button>
        </div>
    );
};

export default LogoutButton;
